window.addEventListener('DOMContentLoaded', () => {

// code from theme.liquid
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (settings.url === "https://zip.appjetty.com//appjetty-zipcode") {
      const estimateDay = $.parseJSON(xhr.responseText);
      const todayDate = new Date();
      let deliveryDate = new Date();
      deliveryDate.setDate(todayDate.getDate() + parseInt(estimateDay.estimated_day));
      date = deliveryDate.toString().split(" ");
      $('.estimation_msg .estimated_days').html("Order Now & Get it by " + date[0] + ", " + date[1] + " " + date[2]);
      $('.success_msg').html("<span>Free Shipping in India for orders above Rs 499</span>" + "<span>Easy 15 days return available</span>");
    }
    if (settings.url.includes("/apps/ssw/lite2/fave?")) {
      $('.ssw-link-fave-menu').trigger('click');
    }
  });

  // code from theme.liquid
  $('.mobile-navigation-drawer .navigation__tier-2 .navigation__children-toggle').trigger('click');

  // code from footer.liquid
  var width = $(window).width();
    if (width <= 480) {
      setTimeout(function() {
        $("#pagefooter .accordion .heading-1").trigger('click');
      },100);
    }
    $(".accordion_head").click(function () {
      if ($('.accordion_body').is(':visible')) {
        $(".accordion_body").slideUp(300);
        $(".plusminus").html('<img src="//cdn.shopify.com/s/files/1/0796/1959/files/Add_Plus.png?v=1651733780" width="24" height="24" >');
      }
      if ($(this).next(".accordion_body").is(':visible')) {
        $(this).next(".accordion_body").slideUp(300);
        $(this).children(".plusminus").html('<img src="//cdn.shopify.com/s/files/1/0796/1959/files/Add_Plus.png?v=1651733780" width="24" height="24" >');
      } else {
        $(this).next(".accordion_body").slideDown(300);
        $(this).children(".plusminus").html('<img loading="lazy" src="https://cdn.shopify.com/s/files/1/0796/1959/files/Add_Minus.png?v=1651733780" width="24" height="24" >');
      }
    });

  // code from theme.liquid
  function initFreshChat() {
    window.fcWidget.init({
      	 token: "9ae8f970-1669-4e10-b1d3-ffcda9112212",
	 host: "https://kushalsretailprivatelimited-org.freshchat.com"
    });
  }
  function initialize(i,t){var e;i.getElementById(t)?
  initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,
  e.src="https://kushalsretailprivatelimited-org.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}
  function initiateCall(){initialize(document,"Freshchat-js-sdk")}
  window.addEventListener?window.addEventListener("load",initiateCall,!1):
  window.attachEvent("load",initiateCall,!1);

  // scroll down for pdp
  $("#view_similar").click(function() {
      $('html,body').animate({                                                         
          scrollTop: $(".section-product-recommendations").offset().top-50},
          900);
  });

    jQuery(".CT_link-dropdown__button").click(function(){
      if(jQuery(".ct_fil_shade").hasClass("ct_fill_active"))
      {
        jQuery("#shopify-section-header").removeClass("ct_active_sort");
        jQuery(".template-collection").removeClass("ct_active_sort_body");
        
        jQuery(".ct_fil_shade").removeClass("ct_fill_active");
      }
      else
      {        
        jQuery("#shopify-section-header").addClass("ct_active_sort");
        jQuery(".template-collection").addClass("ct_active_sort_body");
        
        jQuery(".ct_fil_shade").addClass("ct_fill_active");
      }
    })
  // Disabled DOB on account page
  var dtToday = new Date();
    
    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();
    if(month < 10)
        month = '0' + month.toString();
    if(day < 10)
        day = '0' + day.toString();
    
    var maxDate = year + '-' + month + '-' + day;
    $('#birthday').attr('max', maxDate);

     document.addEventListener('theme:cartchanged', async (e) => {
    try {
      const response = await fetch('/cart.js'); // Adjust endpoint if needed
      const cart = await response.json();
      const itemCount = cart.item_count;
  
      if (itemCount == 1) {
        $('.majortitle [data-cart-count]').html(`(${itemCount} Item)`);
      } else {
        $('.majortitle [data-cart-count]').html(`(${itemCount} Items)`);
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  });

    let freshDeskChatBtn = document.querySelector('.fresh-desk-cart-init');
    if (freshDeskChatBtn) {
      freshDeskChatBtn.addEventListener('click', () => {
        fcWidget.open();
      })
    }
});

// $(document).ready(function () {
//   const result_url = window.AF_SMART_SCRIPT_RESULT?.clickURL || null;

//   if (result_url) {
//     setTimeout(() => {
//       window.AF_SMART_SCRIPT.fireImpressionsLink();
//     }, 1000);
//   }

//   // Call the function with either `result_url` or defaults
//   setHrefForElements(result_url);

//   function setHrefForElements(url) {
//     const defaultAndroidLink = 'https://play.google.com/store/apps/details?id=co.kushals';
//     const defaultIosLink = 'https://apps.apple.com/in/app/kushals-fashion-jewellery/id6450987987';
//     const isAndroid = navigator.userAgent.match(/Android|Opera Mini|IEMobile/i);
//     const isMobile = $(window).width() < 760;
//     const targetUrl = url || (isAndroid ? defaultAndroidLink : defaultIosLink);

//     // Apply mobile-specific logic
//     if (isMobile) {
//       if (isAndroid) {
//         jQuery('.bottom_pop_inner').addClass('ct_Andriod_link');
//       } else {
//         jQuery('.bottom_pop_inner').addClass('ct_IOS_link');
//       }

//       // Update href for relevant elements
//       jQuery('.bottom_pop_inner, .app-download-banner-inner a').prop('href', targetUrl);
//     } else {
//       console.warn("Not a mobile device; skipping mobile-specific logic.");
//     }
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
  
  const resultUrl = window.AF_SMART_SCRIPT_RESULT?.clickURL || null;

  if (resultUrl) {
    setTimeout(() => {
      if (window.AF_SMART_SCRIPT?.fireImpressionsLink) {
        window.AF_SMART_SCRIPT.fireImpressionsLink();
      } else {
        console.warn("AF_SMART_SCRIPT.fireImpressionsLink is not available.");
      }
    }, 1000);
  }

  // Call the function with either `resultUrl` or defaults
  setHrefForElements(resultUrl);
});
  function setHrefForElements(url) {
    const bottomPopElements = document.querySelectorAll('.bottom_pop_inner');
    const appDownloadLinks = document.querySelectorAll('.app-download-banner-inner a');
    const defaultAndroidLink = 'https://play.google.com/store/apps/details?id=co.kushals';
    const defaultIosLink = 'https://apps.apple.com/in/app/kushals-fashion-jewellery/id6450987987';
    const isAndroid = /Android|Opera Mini|IEMobile/i.test(navigator.userAgent);
    const isMobile = window.innerWidth < 760;
    const targetUrl = url || (isAndroid ? defaultAndroidLink : defaultIosLink);

    if (isMobile) {
      if (bottomPopElements.length > 0) {
        bottomPopElements.forEach(element => {
          if(isAndroid){
            element.classList.add('ct_Andriod_link');
          }
          else{
            element.classList.add('ct_IOS_link');
          }
          element.setAttribute('href', targetUrl);
        });
      }

      if (appDownloadLinks.length > 0) {
        appDownloadLinks.forEach(link => link.setAttribute('href', targetUrl));
      }
    }
  }

// FC WIDGET CODE
document.addEventListener('DOMContentLoaded', () => {
  let fcWidgetScroll = false;

  const observer = new MutationObserver((mutationsList, observer) => {
    const freshChatBtn = document.querySelector('#fc_widget');
    if (freshChatBtn) {
      observer.disconnect(); // Stop observing after widget is found

      // Set initial state
      freshChatBtn.style.display = 'none';

      // Add scroll listener
      window.addEventListener('scroll', () => {
        if (window.scrollY > 200 && !fcWidgetScroll) {
          fcWidgetScroll = true;
          freshChatBtn.style.display = 'block';
        }
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

const uniqueId = getCookie("browserUniqueId") || generateUniqueId();
setCookie("browserUniqueId", uniqueId, 365);
 
function setCookie(name, value, days) {
	const date = new Date();
	date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}
function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	return parts.length === 2 ? parts.pop().split(";").shift() : null;
}

function generateUniqueId() {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0,
			v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}